const baseURL = "/v1/Turno";

const service = {
  methods: {
    $buscarTurnos(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarTurno(id) {
      return this.$api().get(`${baseURL}/${id}`);
    },
    $cadastrarTurno(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarTurno(id, body) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarTurno(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
